//should match realm submissionStatuses collection
export class SubmissionStatuses {
  public static readonly SUBMITTED = 'Submitted';
  public static readonly DRAFT = 'Draft';
  public static readonly COMPLETE = 'Complete';
  public static readonly DISMISSED = 'Dismissed';
}
